import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { AbsenceGrantSummary } from '@qaroni-app/absences/types/absence-grant';
import { InputValidation } from '@qaroni-core/utils/validations/input-validation';

@Component({
  selector: 'qaroni-absence-grants-alert',
  templateUrl: './absence-grants-alert.component.html',
  styleUrl: './absence-grants-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: { class: 'block' },
})
export class AbsenceGrantsAlertComponent {
  readonly grants = input<AbsenceGrantSummary[]>([]);
  readonly missing = input<boolean>(false);
  readonly admin = input<boolean>(false);
  readonly grantIdControl = input<AbstractControl | null>(null);
  readonly confirmNewGrantControl = input<AbstractControl | null>(null);
  readonly eventsConfigUrl = input<string>('');
  readonly useExistingGrantChange = output<boolean>();
  readonly goToEventsConfig = output<void>();

  public InputValidation = InputValidation;

  get grantId(): FormControl {
    return this.grantIdControl() as FormControl;
  }

  get confirmNewGrant(): FormControl {
    return this.confirmNewGrantControl() as FormControl;
  }

  get singleGrant(): AbsenceGrantSummary | null {
    return this.grants().length === 1 ? this.grants()[0] : null;
  }

  public onUseExistingGrantChange(checked: boolean): void {
    this.useExistingGrantChange.emit(checked);
  }

  public onGoToEventsConfig(): void {
    this.goToEventsConfig.emit();
  }
}
